// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2LBfn","title":"AfterFrontImage_title__3FAOq"};